// extracted by mini-css-extract-plugin
module.exports = {"tipText":"device-form_tipText_vIpHy","qrcode":"device-form_qrcode_1EOmk","group":"device-form_group_ieUqf","groupOperation":"device-form_groupOperation_4Fhaa"};